import { CONST } from "../../CONST";
import { GridFillScene } from "../../scenes/GridFillScene";
import {Block, BlockConfig} from "./Block";
import GridManager from "./GridManager";

export interface ShapeConfig {
    blocks: BlockConfig[];
    startPos: {x: integer, y: integer};
    blockColor: string;
}

export class Shape {
    public scene: GridFillScene;
    private config: ShapeConfig;
    private gridManager: GridManager;

    private dragStartX !: number;
    private dragStartY !: number;
    private dragXDiff !: number;
    private dragYDiff !: number;

    private gridPos: {x: integer, y: integer};
    private lastFrameGridPos: {x: integer, y: integer};
    private lastValidGridPos: {x: integer, y: integer};

    private blocks: Block[];
    
   constructor(scene: GridFillScene, shapeConfig: ShapeConfig, gridManager: GridManager){
        this.scene = scene;
        this.config = shapeConfig;
        this.gridManager = gridManager;

        this.gridPos = this.config.startPos;
        this.lastFrameGridPos = this.gridPos;
        this.lastValidGridPos = this.gridPos;

        this.blocks = [];
       //Spawn blocks, populate block array
        shapeConfig.blocks.forEach((blockConfig) => {
                this.blocks.push(this.spawnBlock(blockConfig));
        });

        this.gridManager.updateOccupancyMap(this, true);
        this.displayPositionValidity(true);
    }

    private spawnBlock(blockConfig: BlockConfig) : Block{
        return new Block(blockConfig, this, this.scene, this.gridManager.getGridOrigin(), this.gridManager.getCellSize()).setGridPosition(this.gridPos, true);
    }

    public handleDragStart(startX: number, startY: number){
        this.dragStartX = startX;
        this.dragStartY = startY;

        this.gridManager.updateOccupancyMap(this, false);

        this.blocks.forEach((block) => {block.handleDragStart()});

        this.scene.sound.play(CONST.AUDIO.GRAB, {detune: this.scene.getDetune()});
    }

    public handleDrag(dragX: number, dragY: number){
        this.dragXDiff = dragX - this.dragStartX;
        this.dragYDiff = dragY - this.dragStartY;

        var newGridPosCandidate = this.getDragGridPos();
        if (newGridPosCandidate.x !== this.lastFrameGridPos.x || newGridPosCandidate.y !== this.lastFrameGridPos.y){

            let isNewPosValid = this.gridManager.isGridPosValid(newGridPosCandidate, this);
            this.displayPositionValidity(isNewPosValid);
            if (isNewPosValid){
                this.lastValidGridPos = newGridPosCandidate;
            }
        }
        this.lastFrameGridPos = newGridPosCandidate;

        this.blocks.forEach((block) => {block.updateDragPosition(this.dragXDiff, this.dragYDiff)}); //Smooth movement while dragging
    }

    public handleDragEnd(){
        //snap each block to correct position
        this.gridPos = this.lastValidGridPos;
        // this.gridManager.debugLogShapePositions();

        this.blocks.forEach((block) => {block.setGridPosition(this.gridPos)});
        
        this.displayPositionValidity(true);
        this.gridManager.updateOccupancyMap(this, true);
        this.gridManager.checkForBoardCompleted();

        this.scene.sound.play(CONST.AUDIO.GRAB, {detune: this.scene.getDetune()});
    }

    //highlights shape in red if position is not valid
    private displayPositionValidity(posValid: boolean){
        this.blocks.forEach(block => {block.setHighlight(posValid)});
    }

    public fadeOut(){
        this.blocks.forEach(block => block.fadeOut());
    }

    public onGameLost(){
        this.blocks.forEach(block => block.onGameLost());
    }

    public destroy(){
        this.blocks.forEach(block => block.destroy());
    }

    private getDragGridPos(){
        return {
            x: this.gridPos.x + Math.round(this.dragXDiff / this.gridManager.getCellSize()),
            y: this.gridPos.y + Math.round(this.dragYDiff / this.gridManager.getCellSize())
        };
    }

    public collidesWith(shape: Shape, pos: {x: integer, y: integer}){
        return false;
    }


    public getGridPosition(){
        return this.gridPos;
    }

    public getBlockColor(){
        return this.config.blockColor;
    }

    public getBlocks(){
        return this.blocks;
    }
}